import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class RoomMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.room.roomMapperError"));

        Object.setPrototypeOf(this, RoomMapperError.prototype);
    }
}